import { Skeleton, Box, Grid } from '@mui/material';

const OtpSkeleton = () => {
    return (
        <Box sx={{ marginTop: '50px', textAlign: 'center' }}>
            <Skeleton
                variant="text"
                width="80%"
                sx={{ margin: '10px auto 10px' }}
            />
            <Skeleton variant="text" width="60%" sx={{ margin: '10px auto' }} />
            <Skeleton variant="text" width="40%" sx={{ margin: '10px auto' }} />
            <Grid
                container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '20px',
                }}
            >
                {[...Array(6)].map((_, index) => (
                    <Grid item xs={2} sx={{ paddingX: '1.1rem !important' }}>
                        <Skeleton width={'100%'} height={70} key={index} />
                    </Grid>
                ))}
            </Grid>
            <Skeleton
                variant="text"
                width="50%"
                sx={{ margin: '30px auto 10px' }}
            />
        </Box>
    );
};

export default OtpSkeleton;
